import { MobileLineOffer } from './mobileLineOffer'

export const ExtraMobileLineOffer = {
  ...MobileLineOffer,
}
